module.exports = __webpack_public_path__ + "img/rbcn_pro_show_2.42cf880e.jpg";